/* eslint-disable @tanstack/query/exhaustive-deps */
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getADEConnect, GetADEConnection } from '../api/get-ade-connect';
import {
  getFuseSignConnect,
  getFusesignConnect,
  getFuseSignDisconnect,
  getFusesignDisconnect,
} from '../api/get-fusesign-connect';
import { GetXPMConnect, getXPMConnect } from '../api/get-xpm-connect';

type QueryOptions<
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> = Omit<
  UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
  'queryKey' | 'queryFn' | 'enabled'
>;

type ConnectParams = {
  code?: string | null;
  company_id?: string | null; // expects a string | null
};

export const useGetXPMAuthURL = (
  queryOptions?: QueryOptions<GetXPMConnect['return']>,
) => {
  const query = useQuery({
    ...queryOptions,
    queryKey: ['XPMAuthURL'],
    queryFn: () => getXPMConnect({}),
    enabled: false,
  });

  return query;
};

export const useGetXPMConnect = (
  params?: ConnectParams,
  queryOptions?: QueryOptions<GetXPMConnect['return']>,
) => {
  const query = useQuery({
    ...queryOptions,
    queryKey: ['XPMConnect', params?.code, params?.company_id],
    queryFn: () =>
      getXPMConnect({
        code: params?.code ?? undefined,
        company_id: params?.company_id ? Number(params.company_id) : undefined,
      }),
    enabled: Boolean(params?.code || params?.company_id),
  });

  return query;
};

export const useGetADEConnect = (
  params: GetADEConnection['params'] | null,
  queryOptions?: QueryOptions<GetADEConnection['return']>,
) => {
  const query = useQuery({
    ...queryOptions,
    queryKey: ['ADEConnect', params],
    queryFn: () => getADEConnect(params as GetADEConnection['params']),
    enabled: Boolean(params?.company_id && params?.access_token),
  });

  return query;
};

export const useGetFuseSignConnect = (
  queryOptions?: QueryOptions<getFuseSignConnect['return']>,
) => {
  const query = useQuery({
    ...queryOptions,
    queryKey: ['FuseSignConnect'],
    queryFn: () => getFusesignConnect(),
    enabled: true,
  });

  return query;
};

export const useGetFuseSignDisconnect = (
  queryOptions?: QueryOptions<getFuseSignDisconnect['return']>,
) => {
  const query = useQuery({
    ...queryOptions,
    queryKey: ['FuseSignDisconnect'],
    queryFn: () => getFusesignDisconnect(),
    enabled: false,
  });

  return query;
};
